// src/api/deliveryApi.js — Product Delivery Charges backend calls
import { auth } from '../utils/firebase';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

async function getAdminAuthToken() {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Admin is not authenticated');
  }
  return await user.getIdToken();
}

// Admin: geocode the Product Base Location address into lat/lng
export async function geocodeAddress(salonId, address) {
  const token = await getAdminAuthToken();
  const response = await fetch(`${API_BASE_URL}/api/delivery/geocode`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ salonId, address })
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Failed to locate address');
  }
  return data; // { lat, lng, displayName }
}

// Customer-facing: geocode a delivery address and compute the matching charge tier
export async function calculateDeliveryCharge(salonId, address) {
  const response = await fetch(`${API_BASE_URL}/api/delivery/calculate-charge`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ salonId, address })
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Failed to calculate delivery charge');
  }
  return data; // { distanceKm, resolvedAddress, baseLocationAddress, tierName, charge }
}
